import { useSeo } from "@/lib/seo";

const SECTIONS = [
  {
    title: "1. Acceptance of these terms",
    body: "These Terms of Service govern your access to and use of the RentAnything.ai website and software services. By accessing or using the services you agree to be bound by these terms. If you do not agree, do not use the services.",
  },
  {
    title: "2. Description of the service",
    body: "RentAnything.ai provides booking, scheduling, payments, and operations software for rental businesses. Features, pricing, and availability may change as the product evolves.",
  },
  {
    title: "3. Accounts",
    body: "You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. Notify us promptly at inquiry@rentanything.ai of any unauthorized use.",
  },
  {
    title: "4. Acceptable use",
    body: "You agree not to use the services to violate any law, infringe any third-party right, transmit harmful code, attempt to gain unauthorized access, or interfere with the operation of the platform.",
  },
  {
    title: "5. Customer data",
    body: "You retain ownership of the data you upload or capture through the platform. You grant us a limited license to host and process that data solely to provide the services. We will not sell your customer data.",
  },
  {
    title: "6. Payments",
    body: "Paid plans are billed in accordance with the order form or pricing page applicable to your account. Fees are non-refundable except where required by law or expressly stated in the order form.",
  },
  {
    title: "7. Term and termination",
    body: "These terms remain in effect while you use the services. Either party may terminate the agreement in accordance with the applicable order form. Upon termination you may export your data for a reasonable period.",
  },
  {
    title: "8. Disclaimers",
    body: "The services are provided 'as is.' To the maximum extent permitted by law, we disclaim all warranties, express or implied. We do not warrant that the services will be uninterrupted or error-free.",
  },
  {
    title: "9. Limitation of liability",
    body: "To the maximum extent permitted by law, in no event will RentAnything.ai be liable for indirect, incidental, consequential, special, or punitive damages, or for any loss of profits, revenue, or data.",
  },
  {
    title: "10. Changes",
    body: "We may update these terms from time to time. Material changes will be communicated by email or through the product. Your continued use of the services constitutes acceptance of the updated terms.",
  },
  {
    title: "11. Governing law",
    body: "These terms are governed by the laws of the State of Delaware, United States, without regard to its conflict-of-law provisions.",
  },
  {
    title: "12. Contact",
    body: "Questions about these terms? Email inquiry@rentanything.ai.",
  },
];

export default function Terms() {
  useSeo({
    title: "Terms of Service",
    description: "RentAnything.ai terms of service.",
    path: "/terms",
  });
  return (
    <section className="ra-section">
      <div className="ra-container max-w-3xl">
        <header>
          <span className="ra-eyebrow">Legal</span>
          <h1 className="mt-3 ra-h1">Terms of Service</h1>
          <p className="mt-3 text-sm text-ra-ink/60">Last updated: February 5, 2026</p>
        </header>
        <div className="mt-10 space-y-8 text-[16px] leading-[1.75] text-ra-ink/85">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="font-display text-xl font-semibold text-ra-ink">{s.title}</h2>
              <p className="mt-3">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </section>
  );
}
